import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLoanSubmissions,
  fetchLoanBoarded,
  fetchLoanValue,
  fetchLoanNumber,
} from "./api";

const initialState = {
  loanSubmissions: { data: [], status: "idle" },
  loanBoarded: { yearToDate: 0, monthToDate: 0, status: "idle" },
  loanNumbers: { loanYears: 0, loanValue: 0, status: "idle" },
  loanValues: { loanYears: 0, loanValue: 0, status: "idle" },
};

export const submitALoanSlice = createSlice({
  name: "submitALoan",
  initialState,
  reducers: {
    setSubmitALoanStatus: (state, action) => {
      state.loanSubmissions.status = action.payload;
    },
    resetSubmitALoan: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLoanSubmissions.pending, (state) => {
      state.loanSubmissions.status = "loading";
    });
    builder.addCase(fetchLoanSubmissions.fulfilled, (state, action) => {
      state.loanSubmissions.data = action.payload;
      state.loanSubmissions.status = "fulfilled";
    });
    builder.addCase(fetchLoanSubmissions.rejected, (state) => {
      state.loanSubmissions.status = "failed";
    });
    builder.addCase(fetchLoanBoarded.pending, (state) => {
      state.loanBoarded.status = "loading";
    });
    builder.addCase(fetchLoanBoarded.fulfilled, (state, action) => {
      state.loanBoarded.yearToDate = action.payload.yearToDate;
      state.loanBoarded.monthToDate = action.payload.monthToDate;
      state.loanBoarded.status = "fulfilled";
    });
    builder.addCase(fetchLoanBoarded.rejected, (state) => {
      state.loanBoarded.status = "failed";
    });
    builder.addCase(fetchLoanValue.pending, (state) => {
      state.loanValues.status = "loading";
    });
    builder.addCase(fetchLoanValue.fulfilled, (state, action) => {
      state.loanValues.loanValue = action.payload.loanValue;
      state.loanValues.loanYears = action.payload.loanYears;
      state.loanValues.status = "fulfilled";
    });
    builder.addCase(fetchLoanValue.rejected, (state) => {
      state.loanValues.status = "failed";
    });
    builder.addCase(fetchLoanNumber.pending, (state) => {
      state.loanNumbers.status = "loading";
    });
    builder.addCase(fetchLoanNumber.fulfilled, (state, action) => {
      state.loanNumbers.loanValue = action.payload.loanValue;
      state.loanNumbers.loanYears = action.payload.loanYears;
      state.loanNumbers.status = "fulfilled";
    });
    builder.addCase(fetchLoanNumber.rejected, (state) => {
      state.loanNumbers.status = "failed";
    });
  },
});

export const { setSubmitALoanStatus, resetSubmitALoan } =
  submitALoanSlice.actions;

export default submitALoanSlice.reducer;
